module.exports = __webpack_public_path__ + "static/media/isaac_donis.57408b9d.jpg";